import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";

export const getRegistrationRequirementName = (
  requirement: IRequirementResponse
) => requirement.name || "Registration";
